module.exports = ":host .iframe-container--responsive {\n  height: auto;\n  overflow: hidden;\n  padding-bottom: 56.25%;\n  position: relative;\n  width: 100%; }\n  :host .iframe-container--responsive iframe {\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%; }\n  :host .iframe-container--responsive.ratio4x3 {\n    padding-bottom: 75%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/youtube-iframe/youtube-iframe.scss
// module id = 8ZTX
// module chunks = 12